import React from 'react'

import { WijMobielLogo } from '#components/WijMobielLogo'
import { useAuth } from '#hooks/useAuth'
import { useLook } from '#hooks/useLook'
import { useShellTitleState } from '#hooks/useShellTitle'

import { AnnouncementIndicator } from './components/AnnouncementIndicator'
import { OnboardingNudge } from './components/OnboardingNudge'
import { UserChip } from './components/UserChip'
import styles from './styles.module.scss'

/**
 * The white page header under the top bar (DS AppHeader): the logo on the left (classic look; the
 * app look carries it in the top bar), the page title and subtitle in the middle, and the user's
 * notices and chip on the right. The title comes from ShellTitleProvider.
 */
export const AppHeader = (): React.JSX.Element => {
  const { isAuthenticated } = useAuth()
  const look = useLook()
  const { title, subtitle } = useShellTitleState()

  return (
    <header className={styles.header} data-testid="app-header">
      <div className={styles.start}>{look === 'classic' && <WijMobielLogo className={styles.logo} />}</div>

      <div className={styles.titles}>
        {title && (
          <h1 className={styles.title} data-testid="app-header-title">
            {title}
          </h1>
        )}
        {subtitle && (
          <p className={styles.subtitle} data-testid="app-header-subtitle">
            {subtitle}
          </p>
        )}
      </div>

      <div className={styles.end}>
        {isAuthenticated && <OnboardingNudge />}
        {isAuthenticated && <AnnouncementIndicator />}
        <UserChip />
      </div>
    </header>
  )
}
